import { Modal, ICertMasterPlatformUserProduct } from '@comptia-sso/core';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  products?: ICertMasterPlatformUserProduct[];
  onClose: () => void;
};

export const NoActivationNeededModal = ({
  isOpen,
  products,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('NoActivationNeededModal.Title')}
      open={isOpen}
      onClose={onClose}
    >
      <p>{t(`NoActivationNeededModal.Courses`, { count: products?.length })}</p>
      <ul>
        {products?.map((p) => (
          <li key={p.product.productId}>{p.product.productTitle}</li>
        ))}
      </ul>
      <p>
        {t('NoActivationNeededModal.NotUsed', { count: products?.length ?? 0 })}
      </p>
    </Modal>
  );
};
